/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeApprovalReportQuantityEntry } from '../../models/change-approval-report-quantity-entry';

export interface ChangeQuantity$Params {
  workCenterId: number;
  approvalReportDate: string;
  approvalReportLineId: number;
      body: ChangeApprovalReportQuantityEntry
}

export function changeQuantity(http: HttpClient, rootUrl: string, params: ChangeQuantity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, changeQuantity.PATH, 'post');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('approvalReportDate', params.approvalReportDate, {});
    rb.path('approvalReportLineId', params.approvalReportLineId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

changeQuantity.PATH = '/api/v1/workCenter/{workCenterId}/approvals/{approvalReportDate}/items/{approvalReportLineId}/changeQuantity';
